import React, { FC } from "react";
import { Switch } from "react-router-dom";
import { IUser, isPomMainContact } from "domain/user/user";
import { GroupDetailPage } from "pages/groups/group-detail.page";
import { GroupOverviewPage } from "pages/groups/group-overview.page";
import { AvailableBaseRoutes } from "utils/constants";
import { GroupsLeanFilterProvider } from "../../providers/groups/groups-lean-filter-provider";
import { AuthenticatedRoute } from "../../utils/AuthenticatedRoute";
import { GroupType } from "../../domain/group/group-type";

export const GroupRoutes: FC = () => {
  const groupDetailConditionCallback = (user: IUser | undefined) => {
    return isPomMainContact(user);
  };

  return (
    <GroupsLeanFilterProvider>
      <Switch>
        <AuthenticatedRoute path={AvailableBaseRoutes.GroupList} exact allowedRoles={[GroupType.Admin]}>
          <GroupOverviewPage />
        </AuthenticatedRoute>

        <AuthenticatedRoute
          path={AvailableBaseRoutes.GroupDetail}
          exact
          allowedConditionCallback={groupDetailConditionCallback}
        >
          <GroupDetailPage />
        </AuthenticatedRoute>
      </Switch>
    </GroupsLeanFilterProvider>
  );
};
